import React, { Component, Fragment } from 'react';
import { generatePath } from 'react-router-dom';
import DEFINE, { PATHS } from 'constants/Define';
import { isEqual } from 'lodash';
import { HeaderListComponent, PageListComponent } from 'containers/backend/common/component/Index';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Wrapper from 'containers/backend/common/component/Wrapper';
import RenderHotelisActive from '../Hotels/HotelList/RenderHotelisActive';
import * as Func from '../../../../helpers/functions';
import RateCompareList from './RateCompareList/RateCompareList.js';

let permisionActions = [];
export default class RateCompare extends Component{
    constructor(props){
        super(props);
        this.state = {
            filters: {
                hotelId: this.props.match.params.hotel_id,
                pageSize: 1000,
            },
            rateCompareList: [],
        }
    }

    componentDidMount(){
        const { getListRateCompare, getHotelDetail } = this.props
        const { filters } = this.state
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATE_COMPARE);
        getListRateCompare(filters);
        if(filters?.hotelId){
            getHotelDetail(filters.hotelId);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { hotelState } = nextProps;
        if (hotelState.rateCompareList && !isEqual(hotelState.rateCompareList, this.props.hotelState.rateCompareList)) {
            const sortedList = [...hotelState.rateCompareList];            
            sortedList.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
            this.setState({ rateCompareList: sortedList });
        }
    }

    onChangeHotel = (hotelId) => {
        const { getListRateCompare, getHotelDetail, history, match } = this.props;
        const { filters } = this.state;

        if (hotelId) {
            let newFilters = Func.genaratePaginateFilterSort({}, filters, {});
            newFilters.hotelId = hotelId;
            this.setState({ filters: newFilters });
            getListRateCompare(newFilters);
            getHotelDetail && getHotelDetail(hotelId);
            history.replace(generatePath(PATHS.RATE_COMPATE.LIST.path, { hotel_id: hotelId }));
        }
    };

    onClickBack = () => {
        const { match, history } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
            const path = Func.getPathWithParams(PATHS.HOTEL.DETAIL.path, { id: match.params.hotel_id });
            history.push(path);
        }
    };

    render() {
        const { t, match, hotelState } = this.props;
        const { rateCompareList } = this.state;

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        groupPath={'rateCompare'}
                        titleHeader={`${t('navigation.rateCompare')} - ${hotelState?.detail?.hotel?.name || ""}`}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Wrapper style={{ display: 'flex' }}>
                                <RenderHotelisActive
                                    onChangedHotel={this.onChangeHotel}
                                    defaultHotelId={match.params.hotel_id}
                                />
                                <Fragment> {
                                    <Link
                                        to={Func.getPathWithParams(PATHS.RATE_COMPATE.CREATE.path, {
                                            hotel_id: match.params.hotel_id,
                                        })}
                                        className='btn btn-primary'
                                    >
                                        + {t(`action.create`)}
                                    </Link>
                                }
                                </Fragment>
                            </Wrapper>
                        }
                    />
                    <RateCompareList
                        t={t}
                        loading={hotelState.isFetching}
                        rateCompareList={rateCompareList}
                        hotel_id={match.params.hotel_id}
                        deleteRateCompare={this.props.deleteRateCompare}
                    />
                </PageListComponent>
            </Fragment>            
        )
    }
}